import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FaCalendarAlt, FaHotel, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';
import { LuBus } from 'react-icons/lu';
import { formatBookingDate } from 'helpers/utils';
import GoogleMapsLink from 'helpers/googleMapsLink';
import { Card, Button } from 'components/common';
import ShuttleForm from '../itinerary/shuttle/ShuttleForm';
import HotelForm from '../itinerary/hotel/HotelForm';

const Field = ({ label, children }) => (
  <div className="tw-flex tw-gap-2 tw-mb-1.5 tw-text-sm">
    <span className="tw-w-24 tw-flex-shrink-0 tw-font-semibold tw-text-slate-600">{label}</span>
    <span className="tw-text-blue-700 tw-min-w-0 tw-break-words">{children}</span>
  </div>
);
Field.propTypes = { label: PropTypes.node, children: PropTypes.node };

const BookingMultipleStopTrip = ({ booking }) => {
  const [showModalShuttle, setShowModalShuttle] = useState(false);
  const [showModalHotel, setShowModalHotel] = useState(false);
  const [transit, setTransit] = useState(null);
  const { transits, permissions } = booking;
  const { allow_create_shuttle, allow_create_hotel } = permissions || {};

  const openShuttle = (t) => { setTransit(t); setShowModalShuttle(true); };
  const openHotel = (t) => { setTransit(t); setShowModalHotel(true); };

  return (
    <>
      <Card
        padding="none"
        className="tw-mb-3"
        header={<h5 className="tw-mb-0 tw-font-semibold tw-text-slate-800 tw-flex tw-items-center tw-gap-2"><FaMapMarkerAlt /> Multi-stop trips</h5>}
      >
        <div className="tw-bg-slate-50 tw-p-4">
          <h6 className="tw-text-sm tw-text-slate-700 tw-mb-3">Details of a multi-stop trip!</h6>

          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
            {(transits || []).map((t) => (
              <div key={t.id} className="tw-bg-white tw-border tw-border-solid tw-border-slate-200 tw-rounded tw-overflow-hidden">
                <div className="tw-px-4 tw-py-3 tw-border-b tw-border-slate-100 tw-text-blue-700 tw-flex tw-items-center tw-gap-2">
                  <FaMapMarkerAlt /> {t.name} (ID#{t.id})
                </div>
                <div className="tw-p-4">
                  <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                    <div>
                      <h6 className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-slate-500 tw-mb-3">From</h6>
                      <Field label="Date">{formatBookingDate(t.from_date)}</Field>
                      <Field label="Location">{t.from_location}</Field>
                    </div>
                    <div>
                      <h6 className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-slate-500 tw-mb-3">To</h6>
                      <Field label="Date">{formatBookingDate(t.to_date)}</Field>
                      <Field label="Location">{t.to_location}</Field>
                    </div>
                  </div>

                  <div className="tw-mt-3">
                    <Field label="Description"><span dangerouslySetInnerHTML={{ __html: t.description }} /></Field>
                  </div>

                  {(t.shuttles || []).length > 0 && (
                    <div className="tw-mt-4 tw-pt-3 tw-border-t tw-border-dashed tw-border-slate-200">
                      <h6 className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-slate-500 tw-mb-2">Shuttle</h6>
                      {t.shuttles.map((shuttle, i) => (
                        <div key={i} className="tw-mb-2 tw-text-sm tw-text-blue-700">
                          <div className="tw-font-medium tw-mb-1">By {shuttle.name}</div>
                          <div className="tw-flex tw-items-center tw-gap-1"><FaCalendarAlt /> {formatBookingDate(shuttle.departure_date)} ~ {formatBookingDate(shuttle.return_date)}</div>
                        </div>
                      ))}
                    </div>
                  )}

                  {(t.hotels || []).length > 0 && (
                    <div className="tw-mt-4 tw-pt-3 tw-border-t tw-border-dashed tw-border-slate-200">
                      <h6 className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-slate-500 tw-mb-2">Hotel</h6>
                      {t.hotels.map((hotel, i) => (
                        <div key={i} className="tw-mb-2 tw-text-sm tw-text-blue-700">
                          <div className="tw-font-medium tw-mb-1 tw-flex tw-items-center tw-gap-1"><FaHotel /> {hotel.name}</div>
                          <div className="tw-text-xs tw-flex tw-items-center tw-gap-1"><FaPhone /> <a href={`tel:${hotel.tel}`}>{hotel.tel}</a></div>
                          <div className="tw-text-xs"><GoogleMapsLink address={hotel.address} /></div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {(allow_create_shuttle || allow_create_hotel) && (
                  <div className="tw-px-4 tw-py-3 tw-border-t tw-border-slate-100 tw-flex tw-justify-end tw-gap-2">
                    {allow_create_shuttle && <Button size="sm" variant="secondary" leftIcon={LuBus} onClick={() => openShuttle(t)}>Book a shuttle now!</Button>}
                    {allow_create_hotel && <Button size="sm" variant="secondary" leftIcon={FaHotel} onClick={() => openHotel(t)}>Book a hotel now!</Button>}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </Card>

      <ShuttleForm showModal={showModalShuttle} setshowModal={setShowModalShuttle} booking={booking} transit={transit} />
      <HotelForm showModal={showModalHotel} setshowModal={setShowModalHotel} booking={booking} transit={transit} />
    </>
  );
};

BookingMultipleStopTrip.propTypes = {
  booking: PropTypes.object.isRequired,
};

export default BookingMultipleStopTrip;
